
// http://www.htmlgoodies.com/html5/javascript/calculating-the-difference-between-two-dates-in-javascript.html
export function getDaysBetweenDates(from, until) {
	//Get 1 day in milliseconds
	var one_day = 1000*60*60*24; // 86400000

	// Convert both dates to milliseconds
	// var date1_ms = from.getTime();
	// var date2_ms = until.getTime();

	// Calculate the difference in milliseconds
	var difference_ms = until - from;

	// Convert back to days and return
	return Math.round(difference_ms/one_day);
}



// WEBPACK FOOTER //
// ./src/containers/utils/Utils.js